import { UploadFile, Warning } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { FileUploadProgress } from "components/upload/FileUploadProgress";
import { useGeometryUpload } from "components/boundary";
import { ClipConfigProps, ClipStepsControlProps } from "../../clip-menu";
import { BoundaryToolProps } from "./define-boundary";

export const UploadComponent = (
  props: ClipConfigProps & ClipStepsControlProps & BoundaryToolProps
) => {
  const {
    uploadState,
    featureExtractCount,
    warnings,
    uploadProgress,
    isUploading,
    haveUploaded,
    files,
    getRootProps,
    getInputProps,
    resetUpload,
    cancelUpload,
  } = useGeometryUpload({
    draw: props.draw,
    addOrUpdateFeatures: props.addOrUpdateFeatures,
    mapRef: props.mapRef as React.RefObject<any>,
  });

  return (
    <Box>
      {uploadState === "ready" && (
        <>
          <Box
            style={{
              border: "dotted",
              borderColor: "grey",
              margin: "8px",
              padding: "8px",
              textAlign: "center",
            }}
            {...getRootProps({ className: "dropzone" })}
          >
            <input disabled={true} {...getInputProps()} />
            <UploadFile color="info" />
            <Typography>Click to upload or drag and drop file</Typography>
            <Typography variant="body2">*Max file size is 10 MB</Typography>
            <Typography></Typography>
          </Box>
        </>
      )}

      {uploadState === "uploading" && (
        <FileUploadProgress
          uploadProgress={uploadProgress}
          file={files[0]}
          onRemove={cancelUpload}
          isUploading={isUploading}
          haveUploaded={haveUploaded}
        />
      )}
      {uploadState === "processing" && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "16px",
          }}
        >
          <Typography variant="h6">Processing file</Typography>
          <CircularProgress
            sx={{
              marginTop: "16px",
            }}
          />
        </Box>
      )}
      {uploadState === "complete" &&
        warnings.length > 0 &&
        warnings.map((x, i) => (
          <Alert
            key={i}
            sx={{
              marginTop: "16px",
            }}
            icon={<Warning />}
            color="warning"
          >
            {x}
          </Alert>
        ))}
      {uploadState === "complete" &&
        (featureExtractCount > 0 ? (
          <Alert>
            {" "}
            {featureExtractCount} feature(s) extracted successfully
          </Alert>
        ) : (
          <Alert
            sx={{
              marginTop: "16px",
            }}
            icon={<Warning />}
            color="error"
          >
            No features could be extracted
          </Alert>
        ))}
      {uploadState === "complete" && (
        <Button
          sx={{
            marginTop: "16px",
          }}
          onClick={resetUpload}
        >
          Upload again
        </Button>
      )}
    </Box>
  );
};
